/**
 * The public changelog (OD-P16): GET /api/public/changelog, no sign-in. It
 * is the same CHANGELOG.md, parsed by the same code, as the signed-in
 * What's new (GET /api/changelog), so the two can never tell different
 * stories. Nothing here reads or stamps the "seen" state: that belongs to
 * What's new alone.
 *
 * The route's loader starts this fetch (routes/_site/changelog.tsx), so it
 * runs alongside the page's code download, and a hover on a Changelog link
 * warms it up.
 */
import { queryOptions } from '@tanstack/react-query';
import { api, unwrap } from '@/api/client';
import type { components } from '@/api/schema';

export type PublicChangelogEntry = components['schemas']['ChangelogEntryOut'];
export type PublicChangelogSection = components['schemas']['ChangelogSectionOut'];

export const publicChangelogQuery = queryOptions({
  queryKey: ['changelog', 'public'] as const,
  queryFn: () => unwrap(api.GET('/api/public/changelog')),
  staleTime: 5 * 60_000,
});

/** A release's anchor on the page: "v0.2.0-beta" -> "v0.2.0-beta", anything
 *  outside letters, digits, dots and hyphens -> "-". /changelog#v0.2.0-beta
 *  lands on that release. */
export function releaseAnchor(version: string): string {
  return version.trim().replace(/[^a-z0-9.-]+/gi, '-').replace(/^-+|-+$/g, '') || 'release';
}
